$(document).ready(function(){

  const subscribeInfoHTML = `
    <div class="heth-subscribe-info">
      <p class="heth-subscribe-info__title">How subscribe works:</p>
      <div class="heth-subscribe-info__grid">
        <div class="heth-subscribe-info__item">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          <span>Save more with every order</span>
        </div>
        <div class="heth-subscribe-info__item">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          <span>Focus on your day, no order worries.</span>
        </div>
        <div class="heth-subscribe-info__item">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          <span>Cancel anytime – no fees</span>
        </div>
        <div class="heth-subscribe-info__item">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
          <span>Delivered exactly when you need it</span>
        </div>
      </div>
    </div>
  `;

  function injectSubscriptionContent(){
    const $container = $('.appstle_subscription_description_text');
    if ($container.length && $container.find('.heth-subscribe-info').length === 0) {
      $container.html(subscribeInfoHTML);
    }
  }

  // Initial insert
  setTimeout(injectSubscriptionContent, 500);

  $('.heth__swatch-btn').on('click', function(){

    const variantId = $(this).find('.var-price').data('variant-id');
    const content = $('#capsule-content-' + variantId).html();

    $('.heth__content .capsul-size').html(content);

    setTimeout(injectSubscriptionContent, 600);
    setTimeout(updateAddToCartPrice, 600);
  });

function insertPrice(){
  if ($('.heth__atc-btn .price-wrapper').length === 0) {
    $('.heth__atc-btn').append('<span class="price-wrapper"></span>');
  }
}

function getSelectedPrice(){
  const $selected = $('.appstle_subscription_wrapper_option.appstle-active-option, .appstle_subscription_wrapper_option.appstle_selected_background');

  const price = $selected.find('.appstle_subscription_amount').first().text().trim();
  const comparePrice = $selected.find('.appstle_subscription_compare_amount, .appstle_subscription_amount_compare_at_price').first().text().trim();

  return { price, comparePrice };
}

function updateAddToCartPrice(){
  const { price, comparePrice } = getSelectedPrice();

  let priceHTML = '';
  if (comparePrice) {
    priceHTML = `<s>${comparePrice}</s> <strong>${price}</strong>`;
  } else if (price) {
    priceHTML = `<strong>${price}</strong>`;
  }

  insertPrice();
  $('.heth__atc-btn .price-wrapper').html(priceHTML);
}

$(document).on('click', '.appstle_subscription_wrapper_option, .appstle_radio_label, input[name="selling_plan"]', function(){
  setTimeout(updateAddToCartPrice, 200);
});

setTimeout(updateAddToCartPrice, 800);

function downloadPdf(){
  $('.js-force-download').on('click', function(e) {
        var fileUrl = $(this).attr('href');
        
        if (fileUrl && (fileUrl.indexOf('.pdf') !== -1 || fileUrl.indexOf('cdn.shopify.com') !== -1)) {
            e.preventDefault();
            
            $.ajax({
                url: fileUrl,
                method: 'GET',
                xhrFields: {
                    responseType: 'blob'
                },
                success: function(data) {
                    var a = document.createElement('a');
                    var url = window.URL.createObjectURL(data);
                    
                    var filename = fileUrl.substring(fileUrl.lastIndexOf('/') + 1).split('?')[0];
                    
                    a.href = url;
                    a.download = filename || 'download.pdf';
                    $('body').append(a);
                    a.click();
                    
                    // Cleanup memory
                    window.URL.revokeObjectURL(url);
                    $(a).remove();
                },
                error: function() {
                    window.location.href = fileUrl;
                }
            });
        }
    });
}

downloadPdf();


});


// pop up
$(document).ready(function () {
        // Open popup
        $(".capsul-size").on("click", function () {
          $(".heth-popup").addClass("is-open");
        });

        // Close popup when clicking the overlay (outside content)
        $(".heth-popup").on("click", function (e) {
          if ($(e.target).is(".heth-popup")) {
            $(this).removeClass("is-open");
          }
        });

        // Also close when clicking Continue button (ensure it only targets the one inside the popup)
        $(".heth-popup__content .heth-popup__button").on("click", function () {
          $(".heth-popup").removeClass("is-open");
        });
      });



